import { render, staticRenderFns } from "./FafsaReportDetails.vue?vue&type=template&id=048e0bfc&scoped=true&"
import script from "./FafsaReportDetails.vue?vue&type=script&lang=js&"
export * from "./FafsaReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./FafsaReportDetails.vue?vue&type=style&index=0&id=048e0bfc&lang=scss&scoped=true&"
import style1 from "./FafsaReportDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e0bfc",
  null
  
)

export default component.exports